(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["passhero"] && !Shopify.designMode) return;
  try {
    
  class CountdownTimer extends HTMLElement {
    connectedCallback() {
      const raw = this.dataset.target;
      if (!raw) return;
      this.target = new Date(raw).getTime();
      if (Number.isNaN(this.target)) return;

      this.dEl = this.querySelector('[data-days]');
      this.hEl = this.querySelector('[data-hours]');
      this.mEl = this.querySelector('[data-minutes]');
      this.sEl = this.querySelector('[data-seconds]');

      this.tick();
      this.interval = setInterval(() => this.tick(), 1000);
    }

    disconnectedCallback() {
      clearInterval(this.interval);
    }

    tick() {
      const diff = this.target - Date.now();
      if (diff <= 0) {
        this.set(this.dEl, 0);
        this.set(this.hEl, 0);
        this.set(this.mEl, 0);
        this.set(this.sEl, 0);
        clearInterval(this.interval);
        return;
      }
      const d = Math.floor(diff / 86400000);
      const h = Math.floor((diff % 86400000) / 3600000);
      const m = Math.floor((diff % 3600000) / 60000);
      const s = Math.floor((diff % 60000) / 1000);
      this.set(this.dEl, d);
      this.set(this.hEl, h);
      this.set(this.mEl, m);
      this.set(this.sEl, s);
    }

    set(el, v) {
      if (!el) return;
      el.textContent = String(v).padStart(2, '0');
    }
  }

  if (!customElements.get('countdown-timer')) {
    customElements.define('countdown-timer', CountdownTimer);
  }

  } catch(e) { console.error(e); }
})();
})();
